import {getAxiosConfig, handleResponse, withCancellation} from 'Shared/utilities/fetchHelpers';
import axiosInstance from 'Shared/utilities/axiosInstance';
import {RecruiterCodeApi} from 'Users/api/api';

const recruiterCodeApi = new RecruiterCodeApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);

export default {
  searchRecruiterCodes: (recruiterCode: string) =>
    withCancellation(cancelToken =>
      recruiterCodeApi.recruiterCodeSearch(recruiterCode, '1', getAxiosConfig(cancelToken, false)).then(handleResponse)
    ),
};
